$('[data-cart-btn]').click(async function (e) {

    e.preventDefault()

    let $target = $(this);
    let product_container = $target.closest('[data-item-product-id]');

    let cart_label = product_container.find('[data-added]')
    let cart_loading = product_container.find('[data-loading]')

    cart_loading.addClass('show')
    $target.addClass('hidden')

    let productId = e.target.closest('[data-item-product-id]').querySelector('[data-cart-btn]').dataset.productId

    await $.ajax({
        url: '/?wc-ajax=add_to_cart', type: 'POST', data: {
            product_id: productId, quantity: 1
        }, success: async function () {
            await $.ajax({
                url: '/wp-admin/admin-ajax.php', type: 'POST', data: {
                    action: 'get_cart_count'
                }, success: function (quantity) {
                    let value = `<span>${quantity}</span`
                    $('.header__cart-quantity').html(value);
                    cart_label.addClass('show')
                    setTimeout(() => {
                        cart_label.removeClass('show')
                    }, 1500)
                }
            });
            cart_loading.removeClass('show')
            $target.removeClass('hidden')
        }, error: function () {
            console.log('error')
            cart_loading.removeClass('show')
            $target.removeClass('hidden')
        }
    });

});

$('[data-add-to-cart]').click(async function (e) {
    e.preventDefault();

    let $target = $(this)
    let product_id = $('input[name="variation_id"]').val();
    let quantity = $('[data-counter-input]').val();
    let form = $('[ data-product-form]');
    const cart_label = $('[data-added]')

    $target.addClass('product--loading')
    form.addClass('blocked')

    await $.ajax({
        url: '/?wc-ajax=add_to_cart', type: 'POST', data: {
            product_id, quantity
        }, success: async function () {
            await $.ajax({
                url: '/wp-admin/admin-ajax.php', type: 'POST', data: {
                    action: 'get_cart_count'
                }, success: function (quantity) {
                    let cart_quantity = $('[data-header-cart-quantity]')
                    if (cart_quantity) cart_quantity.show().html(`<span>${quantity}</span>`);
                    cart_label.addClass('show')
                    setTimeout(() => {
                        cart_label.removeClass('show')
                    }, 2000)
                }
            });
            $target.removeClass('product--loading')
            form.removeClass('blocked')
        }, error: function () {
            console.log('error')
            $target.removeClass('product--loading')
            form.removeClass('blocked')
        }
    });
});